import * as React from 'react';

import type { UseLoginState } from '@xingternal/crate-hooks-use-login-state';
import { XingletLoader } from '@xingternal/crate-xinglet';

type LayoutSwitcherProps = {
  layout: string;
  loginState: UseLoginState;
  isWillingnessToChangeJobsUsed: boolean;
};

const LayoutSwitcher: React.FC<LayoutSwitcherProps> = ({
  layout,
  children,
  loginState,
  isWillingnessToChangeJobsUsed,
}) => {
  const isGridless = layout === 'zen-gridless' || layout === 'xing-gridless';

  if (layout === 'blank') {
    return <>{children}</>;
  }

  if (!loginState.isLoggedIn) {
    return (
      <XingletLoader
        name="@xingternal/crate-communication-loggedout-layouts"
        isGridless={isGridless}
        isFree={layout === 'find-jobs'}>
        {children}
      </XingletLoader>
    );
  }

  return (
    <XingletLoader
      name="@xingternal/crate-communication-loggedin-layouts"
      layout={layout}
      isGridless={isGridless}
      isWillingnessToChangeJobsUsed={isWillingnessToChangeJobsUsed}>
      {children}
    </XingletLoader>
  );
};

export { LayoutSwitcher };
